import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as Ownedpageanalytics } from "../../../assets/svg/modules/new-page-analytics.svg";

const OPAOverview = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                opa_overview: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    }, []);
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <Ownedpageanalytics className="icon_content fill_svg" />

                        <span className="content_title">Page Analytics Overview</span>
                    </div>
                    <div className="text_content">
                        <p>Do you need detailed information about your owned pages and accounts?</p>
                        <p>{`Head here right away! Connect your accounts and pages and see data getting fetched from all your accounts in one unified place. No more
                        visiting multiple platforms to see how your pages are performing.`}</p>
                        <p>You will find X, Facebook and Instagram already there. We are adding more platforms like LinkedIn and TikTok soon.</p>{" "}
                        {/*Changed Twitter name to X /*}
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/O22H8tAewqU"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default OPAOverview;
